import { render, staticRenderFns } from "./importPartsBox.vue?vue&type=template&id=7776f0cb&scoped=true&"
import script from "./importPartsBox.vue?vue&type=script&lang=js&"
export * from "./importPartsBox.vue?vue&type=script&lang=js&"
import style0 from "./importPartsBox.vue?vue&type=style&index=0&id=7776f0cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7776f0cb",
  null
  
)

export default component.exports